import React, { Component } from 'react'
import { List, Popconfirm, Tooltip } from 'antd'
import { Tag } from 'antd'
import { Row } from 'antd'
import { dateFormat } from '../../../../modules/Utils'
import { dateVal } from '../../../../modules/Utils'
import CustomSpin from '../../../../elements/CustomSpin'
import styled from 'styled-components'

const WrappedSpan = styled.span`
  word-break: break-all;
  display: inline-block;
  overflow: hidden;
  white-space: pre-line;
  width: 100%;
  text-overflow: ellipsis;
`

class ApprovalList extends Component {
  render() {
    const { list, toggleModal, fetching, approve } = this.props
    return (
      <CustomSpin spinning={fetching}>
        <List
          size="small"
          dataSource={list}
          bordered={false}
          renderItem={(item) => (
            <List.Item style={{ width: '100%' }}>
              <List.Item.Meta
                style={{ width: '100%' }}
                title={
                  <Row style={{ width: '100%' }}>
                    {/*<a*/}
                    {/*// onClick={() =>*/}
                    {/*//   toggleModal(true, item.type, item.doc, 'claim')*/}
                    {/*// }>*/}
                    {/*>*/}
                    <strong>{item.title}</strong>
                    {item.type === 'Leave' && (
                      <>
                        <br />
                        <span>
                          {dateFormat(dateVal(item, 'start'))} To: {dateFormat(dateVal(item, 'end'))}
                        </span>
                      </>
                    )}
                    {item.type === 'Claim' && (
                      <>
                        <br />
                        <span>
                          {item.category} Claim for {item.account}
                        </span>
                      </>
                    )}
                    {item.type === 'Sales' && (
                      <>
                        <br />
                        <span>{item.company}</span>
                      </>
                    )}
                    {/*</a>*/}
                    <Popconfirm
                      title="Are you sure to Approve this Document?"
                      onConfirm={() => approve(item)}
                      okText="Yes"
                      cancelText="No">
                      <Tooltip>
                        <Tag
                          style={{
                            float: 'right',
                            cursor: 'pointer',
                          }}
                          color="#87d068">
                          Approve
                        </Tag>
                      </Tooltip>
                    </Popconfirm>
                  </Row>
                }
                description={
                  <Row style={{ width: '300px' }}>
                    <span>{item.name}</span>
                    <br />
                    <span>Submitted: {dateFormat(dateVal(item, 'date'))}</span>
                    <br />
                    <WrappedSpan>{item.desc}</WrappedSpan>
                  </Row>
                }
              />
            </List.Item>
          )}
        />
      </CustomSpin>
    )
  }
}

ApprovalList.propTypes = {}
ApprovalList.defaultProps = {}

export default ApprovalList
